import { React, useState, useEffect } from 'react';
import { environment } from '../../environments/environment';
import { Paper, Button, LinearProgress } from '@mui/material';
import ListItemTag from '../../components/common/ListItemTag';
import ViewProductComponent from './ViewProductComponent';
import { useNavigate } from 'react-router-dom';
import axios from '../../axios-interceptor';
import { CircularProgress } from '@mui/material';
import { useContext } from 'react';
import { StateContext } from '../../contexts/StateContext';
import { useTranslation } from 'react-i18next';
import { PortalApiToken } from '../../services/api/api-token';
import { PortalClientStorage } from '../../services/client-storage/storage';
import { sortAllProductVersions } from '../../utils/versionSorter';
import { Constants } from '../../constants/constants';
const baseURL = environment.baseURL;
export const redirectToProductDocumentOrDownload = () => {
    const redirectURL = PortalClientStorage.getData('redirectURL');
    if (redirectURL !== null && redirectURL?.includes('redirect=')) {
        const urlToNavigate = redirectURL.replace('/#/login?redirect=', '');
        window.open(urlToNavigate, "_blank");
        PortalClientStorage.removeData('redirectURL');
    }
}

export const fetchProducts = (setAllProducts,setProdProductLink) => {
    if (!PortalApiToken.doesTokenExist()) return;
    const startTime = performance.now();
    redirectToProductDocumentOrDownload();
    const fetchProductData = axios.get(`${baseURL}/products`);
    fetchProductData?.then((data) => {
            
            // Sort versions in descending order for all products
            const productsWithSortedVersions = sortAllProductVersions(data?.data?.products);
            
            setAllProducts(productsWithSortedVersions);
            setProdProductLink(productsWithSortedVersions);
            openProductsMenu();
        }).catch((error) => {
            const endTime = performance.now();
            const duration = (endTime - startTime).toFixed(2);
            console.error(`[PRODUCTS API] ERROR after ${duration}ms:`, error);
        });
};

export const filterRequestedProducts = (products, setFilterCalled, filterRequested) => {
    setFilterCalled(true);
    const availableProductsStateArray = ['cancelled', '', 'denied'];
    return products?.filter((prodItem) => (filterRequested ? 
        !availableProductsStateArray?.includes(prodItem?.state) : availableProductsStateArray?.includes(prodItem?.state)));
};

export const viewHandler = (key, prodID, title, setShowView, setProductIndex, navigate) => {
    setProductIndex(key);
    navigate(`/products/${prodID}`);
    setShowView(true);
};

export const requestAccessHandler = (product, setLoading, setRequestedProducts, requestedProducts, reqProducts, setAvailableProducts, currentData, setReqProducts, setAllProducts,setProdProductLink) => {
    setLoading(true);
    let payload = {
        ...currentData,
        email: JSON.parse(window?.localStorage?.getItem('userDetails')).email,
        productId: product?.id,
        productName: product?.name,
        userId: window?.localStorage?.getItem('userId'),
        electricityUtility: currentData?.electricUtility,
        regionState: currentData?.region
    };

    const res = axios.post(`${baseURL}/products/approvals`, payload);
    res?.then(() => {
        setRequestedProducts((prevState) => [...prevState, product.id]);
        if (reqProducts?.length > 0) {
            setReqProducts([...reqProducts, product]);
        } else {
            setReqProducts([product]);
        }
        fetchProducts(setAllProducts,setProdProductLink)
        setAvailableProducts((prevState) => [...prevState]?.filter((obj) => obj.id !== product.id));
        setLoading(false);
    }).catch(() => {})
};

export const deleteBtnHandler = (product, reqProducts, currentData, allProducts, setAvailableProducts, availableProducts, setReqProducts, setAllProducts,setProdProductLink) => {
    if (!PortalApiToken.doesTokenExist()) return;
    const tempRProducts = reqProducts?.filter((el) => el?.id !== product?.id);
    setReqProducts(tempRProducts);
    const deletePayload = {state: "cancelled"};
    if (tempRProducts?.length > 0 && allProducts?.length > 0) {
        const productToAddInAvailableProducts = allProducts?.find((item)=>item?.id == product?.id);
        setAvailableProducts([productToAddInAvailableProducts, ...availableProducts]);
    }

    axios
        .put(`${baseURL}/products/approvals/${product?.requestid}`, deletePayload)
        ?.then(() => {
            fetchProducts(setAllProducts,setProdProductLink);
        }).catch(() => {})
};

export const openProductsMenu = () => {
    const productMenu = document.querySelector('.side-nav-section-Products');
    if (productMenu) {
        const nextSibling = productMenu?.nextElementSibling;
        if (nextSibling && nextSibling?.classList?.contains('MuiCollapse-hidden')) {
            const firstMenuItem = document.querySelector('.BluiInfoListItem-rightComponent');
            firstMenuItem?.click();
        }
    }
};

const ProductHomeComponent = () => {
    const [availableProducts, setAvailableProducts] = useState([]);
    const [requestedProducts, setRequestedProducts] = useState([]);
    const {reqProducts, setReqProducts} = useContext(StateContext);
    const {setProdProductLink} = useContext(StateContext);

    const navigate = useNavigate();

    const {allProducts, setAllProducts} = useContext(StateContext);
    const [currentData, setCurrentData] = useState({
        company: '',
        firstName: '',
        lastName: '',
        phoneNumber: '',
        electricUtility: '',
        title: '',
        country: '',
        region: '',
        email: '',
        region_states: '',
        requestedProducts: [],
    });
    const [loading, setLoading] = useState(false);
    const [showView, setShowView] = useState(false);
    const [filterCalled, setFilterCalled] = useState(false);
    const [avaialbleProductsCalled, setAvaialbleProductsCalled] = useState(false);
    const [circularLoader, setCircularLoader] = useState(true);
    const [productIndex, setProductIndex] = useState(0);
    const [browserLanguage] = useState(window?.navigator?.language);
    const {pageHeader, setPageHeader} = useContext(StateContext);
    const { t } = useTranslation();
          
    const fetchCurrentData = () => {
        if (!PortalApiToken.doesTokenExist()) return;
        const fetchData = axios.get(`${baseURL}/security/account/current`);
        fetchData
            ?.then((data) => {
                setCurrentData({
                    company: data?.data?.data?.company_name,
                    firstName: data?.data?.data?.first_name,
                    lastName: data?.data?.data?.last_name,
                    phoneNumber: data?.data?.data?.phone_number,
                    electricUtility: data?.data?.data?.electric_utility,
                    title: data?.data?.data?.job_title,
                    country: data?.data?.data?.country,
                    region: data?.data?.data?.region_states,
                    requestedProducts: data?.data?.data?.requestedProducts,
                });
                setRequestedProducts(data?.data?.data?.requestedProducts);
                if (allProducts?.length > 0) {
                    const tempRproducts = filterRequestedProducts(allProducts, setFilterCalled, true);
                    setReqProducts(tempRproducts);
                }
            }).catch(() => {})
    };

    useEffect(() => {
        setPageHeader(t('translation:pageHeader.all_products'));  
        fetchProducts(setAllProducts,setProdProductLink);
    }, [])

    useEffect(() => {
        fetchCurrentData();
    }, [allProducts])

    useEffect(() => {
        if(filterCalled && avaialbleProductsCalled) {
            setCircularLoader(false);
        }
    }, [currentData, availableProducts, requestedProducts])

    useEffect(() => {
        if (requestedProducts?.length > 0 && allProducts?.length > 0) {
            const tempReqProducts = filterRequestedProducts(allProducts, setFilterCalled, true);
            setReqProducts(tempReqProducts);
        }

        setAvailableProducts(filterRequestedProducts(allProducts, setAvaialbleProductsCalled, false));
    }, [currentData]);

    useEffect(() => {
        const pageHeaderKey = pageHeader?.toLowerCase().replace(/[&\/\\#, +()$~%.'":*?<>{}]/g, '-tql-')
        let currentMenuElement = document?.querySelector(`.${pageHeaderKey}`);
        currentMenuElement?.classList?.add('selected-nav-item');
        return () => {
           currentMenuElement?.classList?.remove('selected-nav-item')
       }
    })


    return (
        <div data-testid="allProductsComponent" className="all-products-component">
            {showView ? (
                <ViewProductComponent product={reqProducts[productIndex]} />
            ) : (
                <>
                {!circularLoader && <div data-testid="default-view-products">
                            {loading && (
                                <div className="linearProgress-bar">
                                    <LinearProgress />
                                </div>
                            )}

                            <div className="myProducts" data-testid="products">
                        <h2 className='product-headings'>{t('translation:pages.products.products_home_component.myProducts')}</h2>
                                {reqProducts?.length > 0 ? (
                                    reqProducts?.map((product, key) => {
                                        return (
                                            <Paper key={key} elevation={3} className="panel paper-main">
                                                <div className="paper-image-div">
                                                    <img
                                                        src={`/${
                                                            product?.logo?.split('/')?.reverse() &&
                                                            product?.logo?.split('/')?.reverse()[0]
                                                        }`}
                                                        className="paper-logo"
                                                        alt="Product Logo"
                                                    />
                                                </div>

                                                <div className="paper-description-div">
                                            <div className="paper-description-heading" data-testid={`${product?.name}-available`}>{product?.name}</div>
                                                    {product?.approved ? (
                                                        <>
                                                            {product?.subTitle?.length > 0 && (
                                                                <div className="sub-title">{product?.subTitle}</div>
                                                            )}
                                                            <div className="paper-description-version">
                                                        {product?.versions[0]?.name && <div className="current-title">Current version:</div>}
                                                                <div className="current-version">
                                                                    {product?.versions[0]?.name}
                                                                </div>
                                                            </div>
                                                    
                                                        </>
                                                    ) : (
                                                        <div className="pendingText">
                                                    {t('translation:pages.products.products_home_component.pendingText')}
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="paper-button-div" data-testid="buttons-div">
                                                    {product?.approved ? (
                                                        <Button
                                                            id="viewButton"
                                                            variant="contained"
                                                            color="primary"
                                                            className="viewBtn"
                                                            onClick={() =>
                                                                viewHandler(
                                                                    key,
                                                                    product?.id,
                                                                    product?.name,
                                                                    setShowView,
                                                                    setProductIndex,
                                                                    navigate
                                                                )
                                                            }
                                                        >
                                                    {t('translation:pages.products.products_home_component.viewButton')}
                                                        </Button>
                                                    ) : (
                                                        <div className="pending-visual" style={{ display: 'flex' }}>
                                                            <div>
                                                                <ListItemTag
                                                                    id="pending-CODESYS Workbench"
                                                                    fontColor="#333d43"
                                                                    backgroundColor="#f5bf33"
                                                                    label="Pending Approval"
                                                                    className="pendingTag"
                                                                />
                                                            </div>
                                                            <Button
                                                                id="removeButton"
                                                                variant="outlined"
                                                                color="primary"
                                                                className="deleteBtn"
                                                                style={{ marginLeft: 'auto', bottom: '20%' }}
                                                                onClick={() =>
                                                                    deleteBtnHandler(
                                                                        product,
                                                                        reqProducts,
                                                                        currentData,
                                                                        allProducts,
                                                                        setAvailableProducts,
                                                                        availableProducts,
                                                                        setReqProducts,
                                                                        setAllProducts,
                                                                        setProdProductLink
                                                                    )
                                                                }
                                                            >
                                                         {t('translation:pages.products.products_home_component.deleteButton')}
                                                            </Button>
                                                        </div>
                                                    )}
                                                </div>
                                            </Paper>
                                        );
                                    })
                                ) : (
                            <div className='no-products'>
                                <p>
                                {t('translation:pages.products.products_home_component.blockQuoteText')}
                                </p>
                                    </div>
                                )}
                            </div>
                            <div className="availableProducts" style={{ display: 'flex', flexDirection: 'column' }}>
                        <h2 className='product-headings'> {t('translation:pages.products.products_home_component.availableProducts')}</h2>
                                {availableProducts &&
                                    availableProducts?.map((product, key) => {
                                        return (
                                            <Paper key={key} elevation={3} className="avaialbleProducts-paper">
                                                <div className="product-container">
                                                    <div className="product-logo">
                                                <img src={`/${product?.logo?.split('/')?.reverse() && product?.logo?.split('/')?.reverse()[0]}`} alt="Product Logo" className="product-img" />
                                                    </div>

                                                    <div className="product-name">
                                                <div style={{ fontWeight: 'bold', marginRight: '16px' }} className='product-intro'>
                                                            {product?.name}
                                                        </div>
                                                <div className={`product-description ${(product?.descriptionEN?.length || product?.descriptionFR.length) > 350 ? 'description-lenghty' : ''}`}>
                                                            {browserLanguage?.includes(Constants.frenchLanguage)
                                                                ? product?.descriptionFR
                                                                : product?.descriptionEN}
                                                        </div>
                                                    </div>

                                                    <div className="product-requestDiv">
                                                        <Button
                                                            variant="outlined"
                                                            color="primary"
                                                            className="requestAccessBtn"
                                                    data-testid='request-access-btn'
                                                            onClick={() =>
                                                        requestAccessHandler(product, setLoading, setRequestedProducts, requestedProducts, reqProducts, setAvailableProducts, currentData, setReqProducts,setAllProducts,setProdProductLink)
                                                            }
                                                        >
                                                    {t('translation:pages.products.products_home_component.requestAccessButton')}
                                                        </Button>
                                                    </div>
                                                </div>
                                            </Paper>
                                        );
                                    })}
                            </div>
                </div>}
                </>
            )}
            {!circularLoader && availableProducts && availableProducts?.length < 1 && (
                <blockquote className="blockquote" data-testid="availableProductWarning">
                    <p> {t('translation:pages.products.products_home_component.blockQuoteText_1')}</p>
                </blockquote>
            )}
            <div className={`spinner-container ${circularLoader ? 'spinner-margin-25' : 'spinner-margin-0'}`} >
                {circularLoader && <CircularProgress role="progressbar" size={80} className="primary-spinner" />}
            </div>
        </div>
    );
};

export default ProductHomeComponent;
